import L from 'leaflet';

function getColor(count) {
    if (count > 1000) return '#e74c3c'; // rosso
    if (count > 200) return '#f39c12';  // arancione
    if (count > 50) return '#2ecc71';   // verde
    return '#7f8c8d';                   // grigio
}

export function generateMarkerIcon(count) {
    const color = getColor(count);
    const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="48" viewBox="0 0 32 48">
      <path fill="${color}" stroke="#000" d="M16 0C9 0 3 6 3 13c0 10 13 35 13 35s13-25 13-35C29 6 23 0 16 0z"/>
      <circle cx="16" cy="13" r="6" fill="white"/>
    </svg>
  `;
    const url = "data:image/svg+xml;base64," + btoa(svg);

    return new L.Icon({
        iconUrl: url,
        iconSize: [32, 48],
        iconAnchor: [16, 48],
        popupAnchor: [0, -45],
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        shadowSize: [41, 41],
        shadowAnchor: [13, 41]
    });
}
